import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ErrorSummaryFieldComponent } from '../../atoms/forms/error-summary-field/error-summary-field.component';
import { ErrorTypeLabels, FieldLabels, DEFAULT_ERROR_TYPE_LABELS } from '../../shared/interfaces/error-messages.interface';

@Component({
  selector: 'htx-form',
  standalone: true,
  imports: [CommonModule, ErrorSummaryFieldComponent, ReactiveFormsModule],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss'
})
export class FormComponent {

  /** The FormGroup that manages all form fields */
  formGroup = input.required<FormGroup>();

  /** Title for the error summary component */
  errorSummaryTitle = input<string>('Validation Errors');

  /** Whether to show the error summary component */
  showErrorSummary = input<boolean>(true);

  /** Which control names to check for errors. If not provided, all controls are checked */
  controlNames = input<string[] | undefined>(undefined);

  /** Labels for form fields to display in the error summary */
  fieldLabels = input<FieldLabels>({});

  /** Custom labels for error types (required, email, etc.) */
  errorTypeLabels = input<ErrorTypeLabels>(DEFAULT_ERROR_TYPE_LABELS);

  /**
   * Returns whether the form has any errors
   */
  hasFormErrors(): boolean {
    return this.formGroup().invalid && this.formGroup().touched;
  }
}
